module.exports = __webpack_public_path__ + "static/img/Peter-Herweck_2017-18.d9027a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Peter-Herweck_2017-18.jpg
// module id = z3Kl
// module chunks = 0